export default class ApiError extends Error {
	protected code: ApiErrorCode

	constructor(code: ApiErrorCode, message: string) {
		super(message)
		this.code = code
	}

	getCode() {
		return this.code
	}

	setCode(code: ApiErrorCode): ApiError {
		this.code = code
		return this
	}
}

export enum ApiErrorCode {
	Conflict,
	MethodNotAllowed,
	NotFound,
	Unauthorized,
	UnprocessableEntity
}



// WEBPACK FOOTER //
// ./src/error/api-error.ts